export default __webpack_public_path__ + "static/favicon-9fc9a6310388336527797a5cbf348f2e.png";